import React from "react";
import { styled } from "../../stitches.config";

import Link from "../Link";


const Tags = props => {
    const { article } = props;
    return (
        <Link to={article.link}>
            {article.linkName}
        </Link>
    );
};


export default Tags;
